export default __webpack_public_path__ + "static/media/room.6646b32b.svg";